import axios from 'axios';
import { resolveAppErrorKind, showAppError } from '../appError';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Голым axios ходят только RequestStore.vue и RequestStorePagination.vue — остальное
// приложение работает через инстанс из http.js, у которого свой такой же перехватчик.
// Правило «что показывать» у обоих общее и живёт в appError.js.
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const kind = resolveAppErrorKind(error);

        if (kind) {
            showAppError(kind);
        }

        throw error;
    },
);

export default axios;
